// extracted by mini-css-extract-plugin
export default {"pm-info-btn":"Questions_pm-info-btn__XMb5F","reason":"Questions_reason__EO0Ma","finalSubmitCheckbox":"Questions_finalSubmitCheckbox__F2yCy"};